import { z } from 'zod';
import { genderSchema } from '../const/genderSchema';

export const normalizedImportProductSchema = z.object({
    productId: z.string().min(1),
    title: z.string().min(1),
    description: z.string().trim().max(20000).nullable(),
    images: z.array(z.string().url()).default([]),
    categoryName: z.string().optional().nullable(),
    brandName: z.string().optional().nullable(),
    gender: genderSchema,
    sizes: z.array(z.string()).optional().nullable(),
    prices: z.record(z.string(), z.number()).optional().nullable(),
    sellerSpuId: z.string().min(1).optional().nullable(),
});

export const normalizedImportProductPayloadSchema = z.object({
    products: z.array(normalizedImportProductSchema),
});

export type NormalizedImportProductSchema = z.infer<typeof normalizedImportProductSchema>;
export type NormalizedImportProductPayloadSchema = z.infer<typeof normalizedImportProductPayloadSchema>;
